import React, { useState } from "react";
import { Modal, Button, Table } from "react-bootstrap";
import { Eye, X, Search, Calendar, DollarSign, FileText } from "lucide-react";
import "../Css/WeekReport.css";

export default function ViewDiscountModal({ show, onHide, discounts = [] }) {
  const [searchTerm, setSearchTerm] = useState("");

  // Filter discounts based on search term
  const filteredDiscounts = discounts.filter(
    (discount) =>
      discount.note.toLowerCase().includes(searchTerm.toLowerCase()) ||
      discount.date.includes(searchTerm) ||
      discount.amount.toString().includes(searchTerm)
  );

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      centered
      className="viewdiscount-modal"
    >
      <Modal.Header
        className="text-white modal-header"
        style={{ backgroundColor: "var(--primary-color)" }}
      >
        <Modal.Title className="viewdiscount-title" style={{ color: "white" }}>
          Discount History
        </Modal.Title>
        <Button
          variant="link"
          onClick={onHide}
          className="viewdiscount-close-btn"
          style={{ color: "white" }}
        >
          <X size={20} />
        </Button>
      </Modal.Header>

      <div className="viewdiscount-search-container">
        <div className="viewdiscount-search-wrapper">
          <Search size={18} className="viewdiscount-search-icon" />
          <input
            type="text"
            placeholder="Search discounts..."
            className="viewdiscount-search-input"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      <Modal.Body className="viewdiscount-body">
        {filteredDiscounts.length > 0 ? (
          <div className="viewdiscount-table-container">
            <Table responsive className="viewdiscount-table">
              <thead>
                <tr>
                  <th className="viewdiscount-th">
                    <div className="viewdiscount-th-content" style={{ paddingLeft: "12px" }}>
                      <Calendar size={16} />
                      <span>Date</span>
                    </div>
                  </th>
                  <th className="viewdiscount-th">
                    <div className="viewdiscount-th-content">
                      <DollarSign size={16} />
                      <span>Amount</span>
                    </div>
                  </th>
                  <th className="viewdiscount-th">
                    <div className="viewdiscount-th-content">
                      <FileText size={16} />
                      <span>Note</span>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredDiscounts.map((discount, index) => (
                  <tr key={index} className="viewdiscount-tr">
                    <td className="viewdiscount-td" style={{ paddingLeft: "20px" }}>
                      {new Date(discount.date).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                      })}
                    </td>
                    <td className="viewdiscount-td viewdiscount-amount">
                      ${parseFloat(discount.amount).toFixed(2)}
                    </td>
                    <td className="viewdiscount-td viewdiscount-note">
                      {discount.note || (
                        <span className="viewdiscount-no-note">
                          No note provided
                        </span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        ) : (
          <div className="viewdiscount-empty">
            <div className="viewdiscount-empty-icon">
              <FileText size={48} />
            </div>
            <h4>No discounts found</h4>
            <p>
              {searchTerm
                ? "No discounts match your search criteria."
                : "There are no discounts to display."}
            </p>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer className="viewdiscount-footer">
        <div className="viewdiscount-summary">
          <div className="viewdiscount-summary-item">
            <span className="viewdiscount-summary-label">Total Discounts:</span>
            <span className="viewdiscount-summary-value">
              {filteredDiscounts.length}
            </span>
          </div>
          <div className="viewdiscount-summary-item">
            <span className="viewdiscount-summary-label">Total Amount:</span>
            <span className="viewdiscount-summary-value">
              $
              {filteredDiscounts
                .reduce((sum, discount) => sum + parseFloat(discount.amount), 0)
                .toFixed(2)}
            </span>
          </div>
        </div>
        <Button
          variant="secondary"
          onClick={onHide}
          className="viewdiscount-close"
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
